import { useConversationsStore } from '@avanta/shared/stores/chat/conversations';

export const TypingIndicator = (): React.ReactElement | null => {
  const isTyping = useConversationsStore(state => state.isTyping);
  if (!isTyping) return null;

  const dotClasses = [
    'block size-2 rounded-full bg-gray-500 animate-bounce [animation-duration:900ms] [animation-delay:0ms]',
    'block size-2 rounded-full bg-gray-500 animate-bounce [animation-duration:900ms] [animation-delay:150ms]',
    'block size-2 rounded-full bg-gray-500 animate-bounce [animation-duration:900ms] [animation-delay:300ms]',
  ];

  return (
    <div className="flex items-end gap-1 w-fit px-4 py-3 rounded-2xl rounded-tl-none bg-gray-200/90 self-start">
      {dotClasses.map((className, index) => (
        <span key={index} className={className} />
      ))}
    </div>
  );
};
